import { z } from 'zod'

// Test Set Schemas
export const createTestSetSchema = z.object({
  name: z.string().min(1, 'Name is required').max(255),
  description: z.string().optional(),
  systemPrompt: z.string().min(1, 'System prompt is required'),
  model: z.string().default('gpt-4o'),
  temperature: z.number().min(0).max(2).default(0.7)
})

export const updateTestSetSchema = createTestSetSchema.partial()

export const testSetQuerySchema = z.object({
  search: z.string().optional(),
  createdBy: z.string().uuid().optional(),
  page: z.coerce.number().min(1).default(1),
  limit: z.coerce.number().min(1).max(100).default(20)
})

// Test Case Schemas
export const testCaseSchema = z.object({
  question: z.string().min(1, 'Question is required'),
  goldenAnswer: z.string().min(1, 'Golden answer is required'),
  category: z.string().optional(),
  tags: z.array(z.string()).optional(),
  difficulty: z.enum(['easy', 'medium', 'hard']).optional()
})

export const updateTestCaseSchema = testCaseSchema.partial()

export const bulkTestCasesSchema = z.object({
  testCases: z.array(testCaseSchema).min(1, 'At least one test case required')
})

// Evaluation Execution Schema
export const runEvaluationSchema = z.object({
  testSetId: z.string().uuid(),
  gitRef: z.string().min(1, 'Git reference required').optional(), // branch, tag, or commit
  passingScore: z.number().min(0).max(10).default(7)
})

export const evaluationQuerySchema = z.object({
  status: z.enum(['RUNNING', 'COMPLETED', 'FAILED', 'CANCELLED']).optional(),
  page: z.coerce.number().min(1).default(1),
  limit: z.coerce.number().min(1).max(100).default(20)
})

// Type exports
export type CreateTestSet = z.infer<typeof createTestSetSchema>
export type UpdateTestSet = z.infer<typeof updateTestSetSchema>
export type TestSetQuery = z.infer<typeof testSetQuerySchema>
export type TestCase = z.infer<typeof testCaseSchema>
export type UpdateTestCase = z.infer<typeof updateTestCaseSchema>
export type BulkTestCases = z.infer<typeof bulkTestCasesSchema>
export type RunEvaluation = z.infer<typeof runEvaluationSchema>
export type EvaluationQuery = z.infer<typeof evaluationQuerySchema>